import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner"
import { Box } from "@mui/material"
import { StyledButton } from "components/Button/StyledButton"
import { DeviceScanList } from "components/DeviceScanList/DeviceScanList"
import { ScanDeviceDialog } from "components/ScanDeviceDialog/ScanDeviceDialog"
import { Device, DeviceSetup } from "graphql/types"
import { useStoreState } from "hooks/storeHooks"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { isEutGroup } from "store/typeGuards"

type AddDeviceToSetupProps = {
  deviceSetup: DeviceSetup[]
  // eslint-disable-next-line no-unused-vars
  setDeviceSetup: (arg: DeviceSetup[]) => void
}

export const AddDeviceToSetup = (props: AddDeviceToSetupProps) => {
  const { deviceSetup, setDeviceSetup } = props

  const [projectDevices, setProjectDevices] = useState<Device[]>([])
  const [openScanDialog, setOpenScanDialog] = useState(false)
  const [scannedBarcodes, setScannedBarcodes] = useState<string[]>([])
  const [initialBarcode, setInitialBarcode] = useState<string | undefined>(undefined)

  const { projectID, examinationID } = useParams()
  const projectsState = useStoreState((state) => state.projects)

  useEffect(() => {
    const project = projectsState.find((project) => projectID === project?.id)
    if (project) {
      const projDev = project.devices
        .map((item) => {
          if (isEutGroup(item) && item.examinations.some((exam) => exam.id === examinationID))
            return item.devices
          else if (isEutGroup(item)) return null
          else return item
        })
        .flatMap((item) => item)
        .filter((item) => item !== null) as Device[]
      setProjectDevices(projDev)
    }
  }, [projectID, projectsState, examinationID])

  return (
    <Box>
      <StyledButton
        buttonType="custom"
        customIcon={<QrCodeScannerIcon />}
        customText="Scan"
        onClick={() => {
          setInitialBarcode(undefined)
          setOpenScanDialog(true)
        }}
      />

      <DeviceScanList
        devices={projectDevices}
        deviceSetup={deviceSetup}
        setDeviceSetup={setDeviceSetup}
        scannedBarcodes={scannedBarcodes}
        onEditBarcode={(barcode) => {
          setInitialBarcode(barcode)
          setOpenScanDialog(true)
        }}
        onDeleteBarcode={(barcode) => {
          setScannedBarcodes((prev) => prev.filter((code) => code !== barcode))
        }}
      />

      <ScanDeviceDialog
        open={openScanDialog}
        onClose={() => {
          setOpenScanDialog(false)
          setInitialBarcode(undefined)
        }}
        deviceSetup={deviceSetup}
        setDeviceSetup={setDeviceSetup}
        projectDevices={projectDevices}
        onScanned={(barcode) =>
          setScannedBarcodes((prev) => (prev.includes(barcode) ? prev : [...prev, barcode]))
        }
        initialBarcode={initialBarcode}
      />
    </Box>
  )
}
